import styled from "styled-components"

export const Wrapper = styled.div`
  width: 40px;
  height: 40px;
  background-color: var(--lightGray4);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`
